/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExportVacantPositionsGet$Params {
  date_posted?: string;
  date_closed?: string;
}

export function apiExcelExportVacantPositionsGet(http: HttpClient, rootUrl: string, params?: ApiExcelExportVacantPositionsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExportVacantPositionsGet.PATH, 'get');
  if (params) {
    rb.query('date_posted', params.date_posted, {});
    rb.query('date_closed', params.date_closed, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExportVacantPositionsGet.PATH = '/api/Excel/ExportVacantPositions';
